// DEPENDENCIES
import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useFormik } from "formik";
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
// COMPONENTS
import MUIDataTable from "mui-datatables";
import { Button, Modal, Form } from "react-bootstrap";
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import SVG from "react-inlinesvg";
// CUSTOM COMPONENTS
import * as alert from "../../../redux/alertSnackBarRedux";
import * as confirmModal from "../../../redux/confirmModalRedux";
// SERVICES AND HELPERS
import * as intervalTypeService from "../../../services/companyData/intervalTypeService";
import TrainingTypeValidator from "../../../helpers/validators/TrainingTypeValidator";
import { getInputClasses } from "../../../helpers/helper";

const locales = {
    'en-US': require('date-fns/locale/en-US'),
}

const localizer = dateFnsLocalizer({
    format,
    parse,
    startOfWeek: () => startOfWeek(new Date(), { weekStartsOn: 1 }),
    getDay,
    locales,
})

const CompanyCalendarPage = () => {
    const [events, setEvents] = useState([
        {
            id: 0,
            title: '20-626 Vinn Res. (ACM Abatement - Lake Charles)',
            allDay: true,
            start: new Date(2021, 5, 14),
            end: new Date(2021, 5, 14),
        },
        {
            id: 1,
            title: '20-628 Acadia Parish (ACM Abatement)',
            start: new Date(2021, 5, 15),
            end: new Date(2021, 5, 15),
        },
        {
            id: 2,
            title: '20-500-33 1800 WD (ACM Abatement)',
            start: new Date(2021, 5, 21),
            end: new Date(2021, 5, 21),
        },
        {
            id: 3,
            title: '21-001 Annual DCCHT & Lead ZZP',
            start: new Date(2021, 5, 11),
            end: new Date(2021, 5, 11),
        },
        {
            id: 4,
            title: '20-626 Vinn Res. (ACM Abatement - Lake Charles)',
            start: new Date(2021, 5, 15),
            end: new Date(2021, 5, 15),
        },
        {
            id: 5,
            title: '20-463 Dollar Res (rpt)',
            start: new Date(2021, 5, 2),
            end: new Date(2021, 5, 2)
        },
        {
            id: 6,
            title: '20-635 Hick Res (rpt)',
            start: new Date(2021, 5, 2),
            end: new Date(2021, 5, 2)
        },
        {
            id: 7,
            title: '20-566 Vincent Res (rpt) / 20-645 Lott Res (rpt)',
            start: new Date(2021, 5, 2),
            end: new Date(2021, 5, 3)
        },
        {
            id: 8,
            title: '16-032 Excel Shell-Norco',
            start: new Date(2021, 5, 17),
            end: new Date(2021, 5, 17)
        },
        {
            id: 9,
            title: '16-234 Shell Geismar @ 0700',
            start: new Date(2021, 5, 18),
            end: new Date(2021, 5, 18)
        },
        {
            id: 7,
            title: '16-234 Shell Geismar (PCM Sampling)',
            start: new Date(2021, 5, 23),
            end: new Date(2021, 5, 23)
        },
        {
            id: 14,
            title: '20-674 RES Contractors - Honeywell (rpt)',
            start: new Date(new Date().setHours(new Date().getHours() - 3)),
            end: new Date(new Date().setHours(new Date().getHours() + 3)),
        }]);

    return (
        <div className="row">
            <div className="col-lg-12 col-xxl-12">
                <div className={`card card-custom card-stretch gutter-b}`}>
                    <div className="card-header border-0 py-5">
                        <h3 className="card-title align-items-start flex-column">
                            <span className="card-label font-weight-bolder text-dark">
                                Company Calendar
                            </span>
                            <span className="text-muted mt-3 font-weight-bold fz-xs">
                                View Company Calendar
                            </span>
                        </h3>
                        <div className="card-toolbar">
                        </div>
                    </div>
                    <div className="container-fluid mb-lg-10">
                        <Calendar
                            popup
                            localizer={localizer}
                            events={events}
                            startAccessor="start"
                            endAccessor="end"
                            style={{ height: 500 }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default CompanyCalendarPage;